import clsx from 'clsx';
import { type ReactNode } from 'react';
import type { Column, Record } from '../types';
import styles from './actionColumn.module.css';
import { SelectColumn } from './selectableColumn';

export function actionColumn<T extends Record>(
  columnConfig: Omit<ActionColumn<T>, 'id'> = {} as any,
): ActionColumn<T> {
  return {
    header: '',
    id: 'action' as any,
    orderBy: false,

    renderCell(record: T, column: ActionColumn<T>) {
      return (
        <td
          className={clsx(styles.actionCell, column.classes)}
          key={column.id as string}
        >
          {column.renderContent(record, column)}
        </td>
      );
    },

    ...(columnConfig as Partial<SelectColumn<T>>),
  } as ActionColumn<T>;
}

export interface ActionColumn<T> extends Column<T> {
  renderContent(record: T, column: ActionColumn<T>): ReactNode;
}
